module.exports = __webpack_public_path__ + "static/design-cal-2bbb715e2d5348ec067461f278b27c3b.mp4";